import { Nullable } from 'cng-common/models/utils'
import Logger from 'core/utils/Logger'

import { TokenPayload } from './isTokenExpired'

export const readTokenPayload = (value: string): Nullable<TokenPayload> => {
  try {
    const tokenInfo = value.split('.')[1]
    const data = window.atob(tokenInfo)
    return JSON.parse(data)
  } catch (err) {
    Logger.error('Fail to read JWT payload')
    return null
  }
}
